import React from 'react';
import { useReveal } from '../../hooks/useReveal';
import { COLOPHON } from '../../data/team';
import '../../styles/Colophon.css';

const Colophon: React.FC = () => {
  const { ref, revealed } = useReveal<HTMLElement>();

  return (
    <section
      ref={ref}
      className={`colophon psl-reveal${revealed ? ' is-in-view' : ''}`}
    >
      <div className="colophon__rule" aria-hidden="true" />
      <div className="colophon__header">
        <div className="colophon__kicker">— bastidores</div>
        <h2 className="colophon__head">
          Quem construiu <em>este caderno</em>.
        </h2>
        <p className="colophon__intro">
          Voluntários da PSL. O sítio é uma extensão do trabalho diário —
          escrito devagar, em tempo emprestado entre as voltas ao canil.
        </p>
      </div>

      <ul className="colophon__list">
        {COLOPHON.map((entry) => (
          <li key={entry.id} className="colophon__entry">
            <span className="colophon__role">{entry.role}</span>
            <span className="colophon__name">{entry.name}</span>
            {entry.note && (
              <span className="colophon__note">{entry.note}</span>
            )}
          </li>
        ))}
      </ul>

      <div className="colophon__sign">
        <span>com carinho, PSL ✿</span>
      </div>
    </section>
  );
};

export default Colophon;
